import type { Theme } from '@material-ui/core/styles'
import { createTheme } from '@material-ui/core/styles'

const headingText = {
  fontWeight: 500,
  color: '#000433',
}
const variables = {
  palette: {
    primary: {
      main: '#00DEB6',
      light: '#00a27f',
      dark: '#00a27f',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F5A512',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: 'Effra, sans-serif',
    h1: {
      ...headingText,
      fontSize: 26,
      letterSpacing: '-0.26px',
      lineHeight: '31px',
      marginBottom: 18,
    },
    h2: {
      ...headingText,
      fontSize: 26,
      letterSpacing: '-0.26px',
      lineHeight: '31px',
    },
    h3: {
      ...headingText,
      fontSize: 18,
      letterSpacing: 0,
      lineHeight: '23px',
    },
    h4: {
      ...headingText,
      fontSize: 16,
      letterSpacing: '-0.18px',
      lineHeight: '20px',
    },
    h5: {
      ...headingText,
      fontSize: 14,
      letterSpacing: '-0.2px',
      lineHeight: '20px',
    },
    body1: {
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: '-0.23px',
      lineHeight: '22px',
      color: '#4E516B',
    },
    body2: {
      color: '#4E516B',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: '-0.20px',
      lineHeight: '22px',
    },
    button: {
      fontSize: '12px',
      fontWeight: 500,
      letterSpacing: '0.3px',
      lineHeight: '15px',
    },
    caption: {
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '-0.2px',
      lineHeight: '22px',
      color: '#4E516B',
    },
  },
  colors: {
    white: '#FFFFFF',
    bgColor: '#ECF5F8',
    brandDarkGrey: '#000433',
    primary: '#00DEB6',
    primaryDark: '#00a27f',
    primaryLink: '#00837D',
    gold: '#00A193',
    red: '#B91515',
    greenLight: '#cdf3eb',
    grey200: '#F9FAFB',
    grey250: '#EAEBF0',
    grey450: '#4E516B',
    grey480: '#4E516B',
    grey490: '#4E516B',
    grey500: '#4E516B',
    grey550: '#4E516B',
    grey600: '#4E516B',
    grey650: '#4E516B',
    grey800: '#000433',
    fieldBorderColor: ' #4E516B',
  },
  layout: {
    contentHorizontalPadding: 3,
    contentVerticalPadding: 2,
  },
} as const

export type CustomTheme = {
  [Key in keyof typeof variables]: (typeof variables)[Key]
}

declare module '@material-ui/core/styles/createTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Theme extends CustomTheme {}
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface ThemeOptions extends CustomTheme {}
}
export const theme = createTheme(variables)
export type ITheme = Theme
